import { PublicUserType } from 'app/area/administration/edit/constants';
import { PersonActionType } from 'app/area/administration/shared/types';
import { User, UserWireData } from 'app/components/access-panel/shared/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { Value } from 'app/types-shared';
import { ComplexValue } from 'ui';

export const excludeAccessRole = (userData: Partial<UserWireData>, defaultRole: ComplexValue<number>) => {
  if (!(isDefinedIncludingZero(userData?.accessRole?.v) && isDefinedIncludingZero(defaultRole?.value) &&
    userData?.accessRole?.v === defaultRole?.value)) {
    return userData;
  }

  const { accessRole, ...userDataWithoutAccessRole } = userData;

  return userDataWithoutAccessRole;
};

export const displayRolePanel = (
  rolePanelAccess: boolean,
  editMode: boolean,
  accessRole: ComplexValue<number>,
  administrationCentral: boolean,
  read: boolean,
  create: boolean,
  hasRoles: boolean) => {

  if (!rolePanelAccess && !accessRole?.value) {
    return false;
  }

  return (!editMode && !!accessRole && !!accessRole?.value)
    || (!administrationCentral && read && hasRoles && !!accessRole?.value)
    || (hasRoles && administrationCentral)
    || (!!editMode && hasRoles && create)
    || rolePanelAccess;
};

export const displayAssignRolePanel = (rolePanelAccess: boolean, administrationCentral: boolean, editMode: boolean, data: User) =>
  (rolePanelAccess && administrationCentral) || (!editMode && data?.accessToAssignRoles?.length > 0);

export const displayAssignRoleSection = (hasRoles: boolean, accessToAssignRoles: Value[] = []) =>
  hasRoles || accessToAssignRoles.length > 0;

export const getTechnicalUserValue = (
  originalUserTypeValue: number,
  currentUserTypeValue: number,
  technical: boolean,
  actionType: PersonActionType
) => (actionType === PersonActionType.duplicate && currentUserTypeValue === PublicUserType)
  || (actionType !== PersonActionType.duplicate
    && (originalUserTypeValue !== PublicUserType && currentUserTypeValue === PublicUserType || !!technical));
